<template>
    <label class="switchLink">
        <nuxt-link
            v-for="(item, index) in dataSwitchLinks"
            :key="index"
            :to="{ path: item.path }"
            :class="[
                'switchLink__link',
                { 'switchLink__link--active': isRouteActive(item.path) },
            ]"
        >
            {{ item.text }}
        </nuxt-link>
    </label>
</template>

<script>
export default {
    name: 'Links',

    data: () => ({
        dataSwitchLinks: [
            {
                path: '/preise',
                text: 'Privat zahlen',
            },
            {
                path: '/preise/pflegekasse',
                text: 'Erstattung über Pflegekasse',
            },
        ],
    }),

    methods: {
        isRouteActive(id) {
            const path = this.$route.path.replace(/\/$/, '')

            if (path === id) {
                return true
            }
        },
    },
}
</script>

<style lang="stylus">
.switchLink {
    border-radius: 30px;
    border: $cs-slate-100 2px solid;
    display: flex;
    margin-left: auto;
    margin-right: auto;
    position: relative;
    width: fit-content;

    &__link {
        border-radius: inherit;
        color: $cs-slate-400;
        display: block;
        font-size: 14px;
        letter-spacing: 0.3px;
        padding: $cs-spaces.half $cs-space;
        text-align: center;
        text-decoration: none;

        @media $display-breakpoints.sm-and-up {
            font-size: 16px;
            padding: $cs-space $cs-spaces.double;
        }

        &--active {
            background: $cs-white;
            box-shadow: $cs-box-shadow;
            font-weight: bold;
            position: relative;
            z-index: 2;
        }
    }

}
</style>
